"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateProgramFitness = exports.evaluateProgramAccuracy = void 0;
const IrisData_1 = require("../../../data/IrisData");
function getNodeBulk(programData, nodeIdx, inputs) {
    const num_in = inputs.length;
    if (nodeIdx < inputs.length) {
        return inputs[nodeIdx];
    }
    const idxL = parseInt(programData[(nodeIdx - num_in) * 3]);
    const idxR = parseInt(programData[(nodeIdx - num_in) * 3 + 1]);
    const operation = programData[(nodeIdx - num_in) * 3 + 2];
    const lhs = getNodeBulk(programData, idxL, inputs);
    const rhs = getNodeBulk(programData, idxR, inputs);
    if (operation === "+") {
        return lhs.map((i, idx) => {
            return i + rhs[idx];
        });
    }
    if (operation === "-") {
        return lhs.map((i, idx) => {
            return i - rhs[idx];
        });
    }
    if (operation === "*") {
        return lhs.map((i, idx) => {
            return i * rhs[idx];
        });
    }
    throw `Unknown operation: ${operation}`;
}
function getNode(programData, nodeIdx, inputs) {
    const num_in = inputs.length;
    if (nodeIdx < inputs.length) {
        return inputs[nodeIdx];
    }
    const idxL = parseInt(programData[(nodeIdx - num_in) * 3]);
    const idxR = parseInt(programData[(nodeIdx - num_in) * 3 + 1]);
    const operation = programData[(nodeIdx - num_in) * 3 + 2];
    //return `(getNode(data, ${idxL}, num_in)} ${operation} getNode(data, ${idxL}, num_in))`;
    if (operation === "+") {
        return (getNode(programData, idxL, inputs) + getNode(programData, idxR, inputs));
    }
    if (operation === "-") {
        return (getNode(programData, idxL, inputs) - getNode(programData, idxR, inputs));
    }
    if (operation === "*") {
        return (getNode(programData, idxL, inputs) * getNode(programData, idxR, inputs));
    }
    throw `Unknown operation: ${operation}`;
}
function evaluateProgramAccuracy(program, num_in, num_mid, num_out) {
    const programData = program.split(" ");
    const output = new Array();
    let correct = 0;
    let total = 0;
    for (const data of IrisData_1.IrisData) {
        // Get our inputs:
        const inputs = [data[0], data[1], data[2], data[3]];
        // Get our outputs:
        const outputs = new Array();
        for (let i = 0; i < num_out; i++) {
            const ptr = programData[i + num_mid * 3];
            const output = getNode(programData, parseInt(ptr), inputs);
            outputs.push(output);
        }
        const guessIdx = outputs.indexOf(Math.max(...outputs));
        const correctIdx = [
            "Iris-setosa",
            "Iris-versicolor",
            "Iris-virginica",
        ].indexOf(data[4]);
        if (guessIdx === correctIdx) {
            correct = correct + 1;
        }
        total = total + 1;
    }
    return correct / total;
}
exports.evaluateProgramAccuracy = evaluateProgramAccuracy;
function evaluateProgramFitness(program, num_in, num_mid, num_out) {
    return __awaiter(this, void 0, void 0, function* () {
        const programData = program.split(" ");
        const inputsBulk = [
            IrisData_1.IrisData.map((d) => d[0]),
            IrisData_1.IrisData.map((d) => d[1]),
            IrisData_1.IrisData.map((d) => d[2]),
            IrisData_1.IrisData.map((d) => d[3]),
        ];
        const expectedIndexes = IrisData_1.IrisData.map((d) => ["Iris-setosa", "Iris-versicolor", "Iris-virginica"].indexOf(d[4]));
        // Get our outputs:
        const outputs = new Array();
        for (let i = 0; i < num_out; i++) {
            const ptr = programData[i + num_mid * 3];
            const output = getNodeBulk(programData, parseInt(ptr), inputsBulk);
            outputs.push(output);
        }
        // So outputs[0] = prediction 0 x N,
        // We need to:
        const totalEIdxes = Array.apply(null, new Array(outputs[0].length));
        const totalE = totalEIdxes.map((_, idx) => outputs[0][idx]);
        const fitnesses = expectedIndexes.map((eIdx, idx) => {
            const outputsForRow = [outputs[0][idx], outputs[1][idx], outputs[2][idx]];
            const totalE = outputsForRow
                .map((o) => Math.exp(o))
                .reduce((sum, current) => sum + current, 0);
            const predictedE = Math.exp(outputsForRow[eIdx]);
            return Math.log(predictedE / totalE);
        });
        const average = fitnesses.reduce((a, b) => a + b) / fitnesses.length;
        return average;
    });
}
exports.evaluateProgramFitness = evaluateProgramFitness;
